<template>
    <md-button
        v-if="!blockoutDay.inEditMode && !blockoutDay.inAddMode && !isEndDateAlreadyPassed(blockoutDay)"
        :disabled="disableActionButtons && !blockoutDay.inAddMode"
        :class="disableActionButtons && !blockoutDay.inAddMode ? 'md-disabled' : ''"
        title="Delete blockout day"
        class="md-danger md-just-icon md-round"
        @click="handleDeleteBlockoutDay()"
    >
        <md-icon>delete</md-icon>
    </md-button>
</template>

<script>
import { GeneralMixin } from '@/mixins/GeneralMixin';
import { handleRequests } from '@/helpers';

export default {
    name: 'BlockoutDaysDeleteButton',
    mixins: [GeneralMixin],
    props: {
        blockoutDay: {
            type: Object,
            default: () => {},
            required: true
        },
        disableActionButtons: {
            type: Boolean,
            default: false
        },
        isEndDateAlreadyPassed: {
            type: Function,
            required: true
        }
    },
    methods: {
        async handleDeleteBlockoutDay() {
            this.$messageBox
                .show({
                    class: 'sm-modal-container',
                    title: 'Delete Unavailable Day',
                    body: 'Are you sure you want to delete this record? This cannot be undone.',
                    buttons: ['Confirm', 'Cancel']
                })
                .then(async (response) => {
                    if (response.toLowerCase() === 'confirm') {
                        await this.deleteBlockoutDay(this.blockoutDay);
                    }
                });
        },
        async deleteBlockoutDay(blockoutDay) {
            this.$_handleLoaderState(true, 'DELETING...');

            try {
                const url = `/api/team-member-roster-blockoutday/${blockoutDay.teamMemberRosterBlockoutDayId}`;

                const payload = {
                    method: 'delete'
                };

                await handleRequests(url, payload);

                this.$notify({
                    message: 'Successfully deleted unavailable day',
                    type: 'success'
                });

                this.$emit('delete', blockoutDay);
            } catch (e) {
                const message = 'Could not delete unavailable day';

                this.showErrorMessage(this, message, e);
                this.$_handleLoaderState(false);
                this.$emit('delete', null);
            }

            this.imageList = [];
            this.documentList = [];
        },
        showErrorMessage(el, message, error) {
            if (error && error.data && error.status === 400) {
                if (Array.isArray(error.data) && error.data.length > 0) {
                    error.data.forEach((e) => {
                        el.$notify({
                            message: e,
                            type: 'danger'
                        });
                    });
                } else if (typeof error.data === 'string') {
                    el.$notify({
                        message: error.data,
                        type: 'danger'
                    });
                } else {
                    el.$notify({
                        message,
                        type: 'danger'
                    });
                }
            } else {
                el.$notify({
                    message,
                    type: 'danger'
                });
            }
        }
    }
};
</script>
